var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar__cart" },
    [
      _c("icon-button", {
        attrs: {
          icon: _vm.getCartIcon,
          width: "26px",
          height: "21px",
          label: "Open Cart",
        },
        on: {
          click: function ($event) {
            return _vm.$store.dispatch("cart/openSidecart")
          },
        },
        nativeOn: {
          mouseover: function ($event) {
            _vm.cartHighlighted = true
          },
          mouseleave: function ($event) {
            _vm.cartHighlighted = false
          },
        },
      }),
      _c("span", { staticClass: "navbar__cart__quantity" }, [
        _vm._v(_vm._s(_vm.numCartItems)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }